<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="1000">
      <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">{{$t('address_create.new_address')}}</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>{{$t('address_create.new_address')}}</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-select v-model="country" :items="countryCodes" maxlength="2" :label="$t('address_create.country')"></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="city" :label="$t('address_create.city')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="street" :label="$t('address_create.street')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="post_code" :label="$t('address_create.post_code')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="phone" :label="$t('address_create.phone')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field v-model="ref" :label="$t('address_create.ref')"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!editing" color="primary" flat @click="save">{{$t('address_create.save')}}</v-btn>
          <v-btn v-if="editing" color="primary" flat @click="edit">{{$t('address_create.edit')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Address from "@/models/Address.js";
export default {
  props: ["customer", 'countryCodes'],
  data() {
    return {
      editingAddressId: -1,
      editing: false,
      dialog: false,
      country: null,
      city: null,
      street: null,
      post_code: null,
      phone: null,
      ref: null
    };
  },
  watch: {
    dialog(val){
      if(!val){
        this.reset();
      }
    }
  },
  methods: {   
    async save() {
      await Address.create(this.prepareData());
      this.dialog = false;
      this.$emit("addressUploaded");
    },

    async edit(){
      await Address.update(this.editingAddressId, this.prepareData());
      this.dialog = false;
      this.$emit('addressUpdated');
    },

    openForEdit(address){
      this.editing = true;
      this.editingAddressId = address.id;
      this.country = address.country,
      this.city = address.city,
      this.street = address.street,
      this.post_code = address.post_code,
      this.phone = address.phone,
      this.ref = address.ref,
      this.dialog = true;
    },

    prepareData() {
      let data = {
        customer_id: this.customer.id
      };
      if (this.country != null) data["country"] = this.country;
      if (this.city != null) data["city"] = this.city;
      if (this.street != null) data["street"] = this.street;
      if (this.post_code != null) data["post_code"] = this.post_code;
      if (this.phone != null) data["phone"] = this.phone;
      if (this.ref != null) data["ref"] = this.ref;
      return data;
    },

    reset(){
      this.editingAddressId = -1;
      this.editing = false;
      this.dialog = false;
      this.country = null;
      this.city = null;
      this.street = null;
      this.post_code = null;
      this.phone = null;
      this.ref = null;
    }
  }
};
</script>